import { useState } from 'react'

import TextField from 'modules/core/components/TextField'

import { TextField as TextFieldType } from 'modules/marketplace/hooks/integrations/formQuestions/useGetMarketplaceSettings'

interface TextQuestionProps {
  textQuestion: TextFieldType
  currentValue?: string
  onChange: (value: string) => void
}

export const TextQuestion = ({
  currentValue,
  textQuestion: { label, placeholder, defaultValue, description, inputType, required },
  onChange,
}: TextQuestionProps) => {
  const [value, setValue] = useState(currentValue || defaultValue || '')

  const handleChange = (change: string) => {
    setValue(change)
    onChange(change)
  }

  return (
    <TextField
      type={inputType}
      label={label}
      placeholder={placeholder || ''}
      value={value}
      onChange={(change) => handleChange(change)}
      description={description || ''}
      mandatory={required}
    />
  )
}
